import { api } from '@/shared/services/api';

export type BriefingContext = 'morning' | 'afternoon' | 'evening' | 'weekend' | 'milestone' | 'slow-day';

export interface BriefingEntity {
  type: 'client' | 'invoice' | 'amount' | 'date' | 'default';
  label: string;
  id?: string;
  tone?: 'default' | 'urgent' | 'positive' | 'warning';
  href?: string;
}

export interface BriefingAction {
  id: string;
  label: string;
  icon: string;
  variant: 'primary' | 'secondary';
  href?: string;
}

export interface BriefingResponse {
  context: BriefingContext;
  greeting: string;
  paragraphs: Array<{ text: string; entities?: BriefingEntity[] }>;
  actions: BriefingAction[];
  streak?: { label: string; icon: string };
  generatedAt: string;
  expiresAt: string;
  fromCache: boolean;
  source?: 'backend' | 'fallback';
}

export const briefingApi = {
  get: (refresh?: boolean) =>
    api.get<BriefingResponse>('/dashboard/briefing' + (refresh ? '?refresh=1' : '')),
  refresh: () => api.post<BriefingResponse>('/dashboard/briefing/refresh'),
  feedback: (body: { context: string; rating: 'up' | 'down'; generatedAt: string }) =>
    api.post<{ ok: boolean }>('/dashboard/briefing/feedback', body),
  feedbackStats: () => api.get<BriefingFeedbackStats>('/dashboard/briefing/feedback/stats'),
};

export interface BriefingFeedbackStats {
  overall: { up: number; down: number; total: number; upPct: number };
  byContext: Record<string, { up: number; down: number; total: number; upPct: number }>;
}
